import React, { useCallback } from 'react'

import Checkbox from '../../../../components/Form/Checkbox'
import ErrorMessage from '../../../../components/Form/ErrorMessage'

import { CUSTOM_AGE_RANGES } from '../../../ReusableFormFields/AgeRangesFields/fields'
import {
  AGE_RANGE_18_24,
  AGE_RANGE_25_34,
  AGE_RANGE_35_44,
  AGE_RANGE_45_54,
  AGE_RANGE_55_64,
  AGE_RANGE_65_PLUS
} from '../../fields'

const Dv360CustomAgeRanges = ({ formik }) => {
  const { values, touched, errors, setFieldValue } = formik

  const checkCustomAgeRangeHandler = useCallback(
    e => {
      setFieldValue(CUSTOM_AGE_RANGES, {
        ...values[CUSTOM_AGE_RANGES],
        [e.target.name]: !values[CUSTOM_AGE_RANGES][e.target.name]
      })
    },
    [setFieldValue, values]
  )

  return (
    <>
      <Checkbox
        id="checkbox_age_18_24"
        title="18-24"
        isLarge
        name={AGE_RANGE_18_24}
        checked={values[CUSTOM_AGE_RANGES][AGE_RANGE_18_24]}
        onCheck={checkCustomAgeRangeHandler}
      />
      <Checkbox
        id="checkbox_age_25_34"
        title="25-34"
        isLarge
        name={AGE_RANGE_25_34}
        checked={values[CUSTOM_AGE_RANGES][AGE_RANGE_25_34]}
        onCheck={checkCustomAgeRangeHandler}
      />
      <Checkbox
        id="checkbox_age_35_44"
        title="35-44"
        isLarge
        name={AGE_RANGE_35_44}
        checked={values[CUSTOM_AGE_RANGES][AGE_RANGE_35_44]}
        onCheck={checkCustomAgeRangeHandler}
      />
      <Checkbox
        id="checkbox_age_45_54"
        title="45-54"
        isLarge
        name={AGE_RANGE_45_54}
        checked={values[CUSTOM_AGE_RANGES][AGE_RANGE_45_54]}
        onCheck={checkCustomAgeRangeHandler}
      />
      <Checkbox
        id="checkbox_age_55_64"
        title="55-64"
        isLarge
        name={AGE_RANGE_55_64}
        checked={values[CUSTOM_AGE_RANGES][AGE_RANGE_55_64]}
        onCheck={checkCustomAgeRangeHandler}
      />
      <Checkbox
        id="checkbox_age_65_plus"
        title="65+"
        isLarge
        name={AGE_RANGE_65_PLUS}
        checked={values[CUSTOM_AGE_RANGES][AGE_RANGE_65_PLUS]}
        onCheck={checkCustomAgeRangeHandler}
      />
      {touched[CUSTOM_AGE_RANGES] && errors[CUSTOM_AGE_RANGES] && <ErrorMessage error={errors[CUSTOM_AGE_RANGES]} />}
    </>
  )
}

export default Dv360CustomAgeRanges
